
import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core'
import { Router, ActivatedRoute, Params } from '@angular/router';
import { sla, kpiRelease, quater, year, kpi, kpiInbox, kpiViewComment, kpiViewWorkFlow, kpiband, kpiNotification, kpiDynamic } from './../../../models/slakpi';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { division, user } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { KPIAllHistoryComponent } from './../../../component/slakpi/kpi-allhistory/kpi-allhistory.component';
import { ToasterService } from '../../../toaster.service';
import { Workbook } from 'exceljs';
import { RSAHelper } from '../../../models/RSAHelper';
@Component({
  selector: 'kpi-inbox',
  templateUrl: './kpi-inbox.component.html',
  styleUrls: ['./kpi-inbox.component.css']


})
export class KPIInboxComponent implements OnInit {

  public sli_data: any;
  modalRef: BsModalRef;
  modalInfoRef: BsModalRef;
  public kpiInbox_data: any;
  loadinginbox: boolean = false;
  public kpiInbox_data_count: any;
  public kpiViewComment_data: any;
  public kpiViewIssue_data: any;
  public kpiViewJustification_data: any;
  public yearData: any;
  public quaterData: any;
  public division_data: any;
  public frequency_data: any;
  public isJustificationDisabled: boolean = false;
  public slaUno?: number = 0;
  public yearUno?: number = 0;
  public quarterUno?: number = 0;
  public divisionUno?: number = 0;
  public frequencyUno?: number = 0;
  public selectedTab?: string = 'Release';
  public condition3_data: any;
  public objkpiInbox_selecteddata: kpiViewWorkFlow;
  public kpiRuleForm: FormGroup;
  public kpiCodeDetail: kpiInbox;
  public actualTrend: string = '';
  public NANRVal: string = '';
  public band_calculated: string = '';
  public kpiTrnUno: number = 0;
  public kpiViewBand_data: any;
  public actualTargetValue: number;
  public chkVisible: boolean = true;
  columnDefinitions: Column[];
  columnDefinitionsApproval: Column[];
  columnDefinitionsCompleted: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any=[];
  gridOptionsHistory: GridOption;
  gridOptionsHistory_new: GridOption;
  columnCommentDefinitions: Column[];
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  issueGrid: AngularGridInstance;
  datasetIssues: any;
  columnIssueDefinitions: Column[];
  //Syncfusion COntrol value assignment
  @ViewChild('BandDialog', { static: false }) BandDialog: TemplateRef<any>;

  @ViewChild('CommentDialog', { static: false }) CommentDialog: TemplateRef<any>;
  @ViewChild('ApproveDialog', { static: false }) ApproveDialog: TemplateRef<any>;
  @ViewChild('RejectDialog', { static: false }) RejectDialog: TemplateRef<any>;
  @ViewChild('KPIDataEntryDialog', { static: false }) KPIDataEntryDialog: TemplateRef<any>;

  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public pageSettings_Justfication: Object;
  public toolbar_Justfication: Object;
  public columns_action: any;
  //Load More Flags
  public formatoptions: Object;
  isToggle: boolean = false;
showMyContainer: boolean = false;

  public commentStartIndex: number = 1;
  public commentMaxCount: number = 5;
  public disableMore: boolean = true;
  public checkboxDisable: boolean = true;
  public isStart: boolean = true;
  public isDataEntryError: boolean = false;
  public txtDataEntryError: string = '';
  public isRejectError: boolean = false;
  public txtRejectError: string = '';
  public onApproveTabSelected: boolean = true;
  //for KPI All Hisory Dialog
  public kpiUnoSelected: number = 0;
  public selectedUserUno: number = 0;
  public kpiTrnUno_poped: number = 0;
  public kpinameSelected: string = '';
  @ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: TemplateRef<any>;
  enableHisGrid: boolean = false;

  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  currentType?: string = 'Data Entry';
  approveComment?: string = '';
  rejectComment?: string = '';
  isAdmin: boolean = false;
  isRowSelected: boolean = false;
  public scrollSettings: any;
  public currentLevelUser: string = '';
  public currentLevel: number;
  public isCurrentLevelUser: boolean = false;
  enableGrid: boolean = true;
  public filterDataCollection: number = 0;
  public filterOverdue: number = 0;
  public filterCompleted: number = 0;
  public filterApproval: number = 0;
  public filterColor: string = '';

  public filterAll_classactive: string = 'active';
  public filterDataCollection_classactive: string = '';
  public filterOverdue_classactive: string = '';
  public filterCompleted_classactive: string = '';
  public filterApproval_classactive: string = '';

  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterApprovalCount: number = 0;

  public filterYear_default: number = 0;
  public filterQuarter_default: number = 0;
  public filterSla_default: number = 0;
  public filterDivision_default: number = 0;
  public filterFrequency_default: number = 0;
  public filterBy_default: number = 0;
  public checkboxcheckLoaded: boolean = false;
  // The Dialog shows within the target element.
  public targetElement: HTMLElement;


  //for KPI details
  public kpinameSelectedKpiInfo: string = '';
  public kpiUnoSelectedKpiInfo: number = 0;
  noDataImg: any;
  tenantUno: any;
  @ViewChild('KPIDetailsHistoryDialog', { static: false }) KPIDetailsHistoryDialog: TemplateRef<any>;
    searchText: string;
    dataSearch: any[];

  public trnDynamicLabel_data: any = [];
  public dynamicLabel_data: any = [];
  public dynamicBinding_data: any = [];
  public uploadedFiles: Array<File> = [];
  public isDynamicEntry: string = 'false';
  public dynamicLabelDisplay: string;
  public fileItemCount: number = 0;
  isDigitalDewa: boolean = false;
  slaName: string = '';
    
  user_data_filter: any;
  isTabClik: boolean=false;
  strkpiname: string = '';

  isDataEntryGrid: boolean = true;
  isApprovalsGrid: boolean = false;
  isCompletedGrid: boolean = false; 
  datasetApproval: any=[];
  datasetCompleted: any=[];
    kpiNameText: any;
  periodText: any;
  actualValueText: any;
  targetValueText: any;
    scheduleText: any;
  constructor(public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute, private toaster: ToasterService,private modalService: BsModalService, public adminService: AdminApiService, public utilityService: UtilityService,
    private spinner: SpinnerVisibilityService, private router: Router, private userService: UserService,
    private kpiAllHistoryComponent: KPIAllHistoryComponent, public RASHelper: RSAHelper) {

    //Load Default Values
    this._activatedRoute.params.subscribe((params: Params) => {

      this.filterApproval_classactive = ''; this.filterApproval = 0;
      this.filterDataCollection_classactive = ''; this.filterDataCollection = 0;
      this.filterCompleted_classactive = ''; this.filterCompleted = 0;
      this.currentType = 'Data Entry';
      if (params['pagetype'] != null) {
        if (params['pagetype'] == 'completed') {
          this.filterCompleted_classactive = 'active';
          this.filterCompleted = 1;
          this.chkVisible = false;
          this.currentType = 'Completed';
          //this.onfilterData('completed', '');
        } else if (params['pagetype'] == 'dataentry') {
          this.filterDataCollection_classactive = 'active';
          this.filterDataCollection = 1;
          this.chkVisible = false;
          this.currentType = 'Data Entry';
          // this.onfilterData('data', '');
        }
        else {
          this.filterApproval_classactive = 'active';
          this.filterApproval = 1;
          this.chkVisible = true;
          this.currentType = 'Approvals';
          //this.onfilterData('approval', '');
        }
      }

      else {
        //this.filterApproval_classactive = 'active';
        //this.filterApproval = 1;
        //this.chkVisible = true;
        ////this.onfilterData('approval', '');
        this.filterDataCollection_classactive = 'active';
        this.filterDataCollection = 1;
        this.chkVisible = false;
        this.currentType = 'Data Entry';
      }
      
      this.user = this.userService.getUserInfo();
      this.login_UserID = this.user.id;
      this.noDataImg = this.utilityService.getnodataImage();
      this.tenantUno = this.user.tenantUno;
      this.isDynamicEntry = this.user.isDynamicEntry;
      this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin') ? true : false;
      this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
      this.currentYear = (this.isAdmin) ? this.user.currentYear : this.user.currentYear;
      this.currentHalf = this.user.currentHalf;
      this.currentQuarter = (this.isAdmin) ? this.user.currentQuarter : this.user.currentQuarter;
      this.currentMonth = this.user.currentMonth;
      this.objkpiInbox_selecteddata = new kpiViewWorkFlow();
      this.kpiCodeDetail = new kpiInbox();
      this.slaName = this.user.slaname;
      //this.filterApproval_classactive = 'active';
      //this.filterApproval = 1;

     
      this.assignDefaultFilter();
      this.scrollSettings = { width: 550, height: 300, frozenColumns: 2 };
      this.loadFilterValues();
      this.loadFrequency();
      this.condition3_data = [
        { text: 'Pass', value: 'Pass' },
        { text: 'Fail', value: 'Fail' },
      ];
      //this.selectionOptions = { type: 'Multiple', checkboxOnly: true };
    });
  }


  ngOnInit() {
    
    
      this.userService.CheckLogin();
    this.isDataEntryGrid=true;
    this.formInit();
    this.isRowSelected = false;
    //this.initilaizeTarget();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [100, 200, 300, 400, 500],
        pageSize: 50
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: true,
      checkboxSelector: {
        // optionally change the column index position of the icon (defaults to 0)
        // columnIndexPosition: 1,

        // remove the unnecessary "Select All" checkbox in header when in single selection mode
        hideSelectAllCheckbox: false,

        // you can override the logic for showing (or not) the expand icon
        // for example, display the expand icon only on every 2nd row
        // selectableOverride: (row: number, dataContext: any, grid: any) => (dataContext.id % 2 === 1)
      },
      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },

    };



    this.gridOptionsHistory = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    //this.gridOptionsHistory = {
    //  autoHeight: true,
    //  enableAutoResize: true,
    //  enablePagination: true,
    
    //  pagination: {
    //    pageSizes: [5, 10, 20, 50, 100, 500],
    //    pageSize: 20
    //  },
    //  enableFiltering: true,
    //  alwaysShowVerticalScroll: false,
    //  enableRowSelection: true,
    //  autoResize: {
    //    containerId: 'myTabContent',
    //    delay: 0,
    //    sidePadding: 10,
    //    bottomPadding: 10
    //  },
    //  enableExcelExport: true,
    //  enableExcelCopyBuffer: true,
    //  enableFilterTrimWhiteSpace: true,
    //  showCustomFooter: true, // display some metrics in the bottom custom footer
    //  enableContextMenu: true,
    //  enableCellMenu: true,
    //  forceFitColumns: true,

    //};
    this.getUsers();
    this.setColnDefn();
  }


  //// Initialize the Dialog component's target element.
  //initilaizeTarget: EmitType<object> = () => {
  //  this.targetElement = document.body;
  //}

  formInit() {

    this.kpiRuleForm = new FormGroup({
      justification: new FormControl(),
      cmntApproval: new FormControl(),
      enteredTargetValue: new FormControl(),
      selectNANR: new FormControl(),
      selectPassFail: new FormControl()
    });

  }
  //Get Default Filter values for retaining the values
  assignDefaultFilter() {

    this.filterYear_default = 0;
    this.filterQuarter_default = 0;
    this.filterSla_default = 0;
    this.filterDivision_default = 0;
    this.filterFrequency_default = 0;

    var objFilterItem = this.utilityService.InboxFilter_get();
    if (objFilterItem != null && objFilterItem != undefined) {
      if (objFilterItem.sla != 0) {
        this.filterSla_default = objFilterItem.sla;
      }
      if (objFilterItem.year != 0) {
        this.filterYear_default = objFilterItem.year;
      }
      if (objFilterItem.quater != 0) {
        this.filterQuarter_default = objFilterItem.quater;
      }
      if (objFilterItem.division != 0) {
        this.filterDivision_default = objFilterItem.division;
      }
      if (objFilterItem.frequency != 0) {
        this.filterFrequency_default = objFilterItem.frequency;
      }

    }
  }

  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {

        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          if (this.filterSla_default > 0)
            setTimeout(() => { this.slaUno = this.filterSla_default; }, 10);
          //if (this.isAdmin)

          this.yearUno = (this.filterYear_default > 0) ? this.filterYear_default : Number(this.currentYear);

          this.quarterUno = (this.filterQuarter_default > 0) ? this.filterQuarter_default : Number(this.currentQuarter);

          if (this.filterDivision_default > 0)
            this.divisionUno = this.filterDivision_default;
          //Load Inbox default value
          //this.loadKPIInbox();
          //this.loadKPIInboxCount();
          this.loadInboxDefaults();
        }, 230);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  loadInboxDefaults() {
    
    if (this.filterDataCollection == 1) {
      this.isDataEntryGrid = true;
      this.isApprovalsGrid = false;
      this.isCompletedGrid = false;
      this.loadKPIInbox();
    }
    else if (this.filterApproval == 1) {
      this.isDataEntryGrid = false;
      this.isApprovalsGrid = true;
      this.isCompletedGrid = false;
      this.loadKPIInboxApprovals();
    }
    else if (this.filterCompleted == 1) {
      this.isDataEntryGrid = false;
      this.isApprovalsGrid = false;
      this.isCompletedGrid = true;
      this.loadKPIInboxCompleted();
    }
    this.loadKPIInboxCount();


    
  }
  //load frequency values
  loadFrequency() {
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.filterFrequency_default > 0) {
      setTimeout(() => { this.frequencyUno = this.filterFrequency_default; }, 10);
    }

  }


  // Get kpi inbox list
  loadKPIInbox() {
    
    let inpValue = new kpiInbox();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.loading = true;
    this.spinner.show();
    inpValue.slaUno = (this.filterSla_default > 0) ? this.filterSla_default : this.slaUno;
    inpValue.slaRuleUno = (this.filterFrequency_default > 0) ? this.filterFrequency_default : this.frequencyUno;
    inpValue.reportingDivisionUno = (this.filterDivision_default > 0) ? this.filterDivision_default : this.divisionUno;

    inpValue.currentYear = (this.filterYear_default > 0) ? this.filterYear_default : this.currentYear;
    inpValue.currentQuarter = (this.filterQuarter_default > 0) ? this.filterQuarter_default : this.currentQuarter;
    inpValue.currentMonth = this.currentMonth;
    inpValue.currentHalf = this.currentHalf;
    inpValue.filterDataCollection = this.filterDataCollection;
    inpValue.filterOverdue = this.filterOverdue;
    inpValue.filterApproval = this.filterApproval;
    inpValue.filterCompleted = this.filterCompleted;
    inpValue.filterColor = this.filterColor;
    inpValue.isAdmin = this.isAdmin;
    this.kpiInbox_data = [];
    this.selectedUserUno = 0;
    
   
    if (!this.loadinginbox) {

      this.dataSearch = [];
      this.dataset = [];
      
     // this.loading = true;
      this.loadinginbox = true;
      this.restApi.getKpiInbox(inpValue)
        .subscribe(data => {
          try {

            
          let rtnData: any = data;
            this.kpiInbox_data = rtnData.data;
           
            const mockDataset = this.kpiInbox_data;
         
            
          
          setTimeout(() => {
            this.dataSearch = mockDataset;
            this.dataset = mockDataset;
            this.columnDefinitions = [];
           

            if (mockDataset.length > 0) {
              this.setColnDefn();
            }

            //Load More
            //if (this.currentType != 'Approvals1') {
              //inpValue.condition = 4;
              //this.loadMoreKPIInbox(inpValue);
            //}



           // this.spinner.hide();
            //this.loading = false;
            this.loadinginbox = false;
            
          }, 200);

          } catch (e) {
           // this.spinner.hide();
            
           // this.loading = false;
            this.loadinginbox = false;
          }

          

          //this.spinner.hide();
          this.isStart = false;
          //this.groupOptions = { columns: ['slaName'] };
          // this.loadKPINotification();
        },
          (error) => {
            //Called when error
            //this.spinner.hide();
            
            //this.loading = false;
            this.loadinginbox = false;
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();

        });
    }
  }

  loadKPIInboxApprovals() {
    
    let inpValue = new kpiInbox();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.loading = true;
    this.spinner.show();
    inpValue.slaUno = (this.filterSla_default > 0) ? this.filterSla_default : this.slaUno;
    inpValue.slaRuleUno = (this.filterFrequency_default > 0) ? this.filterFrequency_default : this.frequencyUno;
    inpValue.reportingDivisionUno = (this.filterDivision_default > 0) ? this.filterDivision_default : this.divisionUno;

    inpValue.currentYear = (this.filterYear_default > 0) ? this.filterYear_default : this.currentYear;
    inpValue.currentQuarter = (this.filterQuarter_default > 0) ? this.filterQuarter_default : this.currentQuarter;
    inpValue.currentMonth = this.currentMonth;
    inpValue.currentHalf = this.currentHalf;
    inpValue.filterDataCollection = this.filterDataCollection;
    inpValue.filterOverdue = this.filterOverdue;
    inpValue.filterApproval = this.filterApproval;
    inpValue.filterCompleted = this.filterCompleted;
    inpValue.filterColor = this.filterColor;
    inpValue.isAdmin = this.isAdmin;
    this.kpiInbox_data = [];
    this.selectedUserUno = 0;
   
   
    if (!this.loadinginbox) {

      this.dataSearch = [];
      this.datasetApproval = [];
      
      this.loading = true;
      this.loadinginbox = true;
      this.restApi.getKpiInbox(inpValue)
        .subscribe(data => {
          try {

            
            let rtnData: any = data;
            this.kpiInbox_data = rtnData.data;
         
            const mockDataset = this.kpiInbox_data;

            

            setTimeout(() => {
              this.dataSearch = mockDataset;
              this.datasetApproval = mockDataset;
              this.columnDefinitionsApproval = [];


              if (mockDataset.length > 0) {
                this.setColnDefnApprovals();
              }

              



              this.spinner.hide();
              this.loading = false;
              this.loadinginbox = false;
              
            }, 200);

          } catch (e) {
            this.spinner.hide();
            
            this.loading = false;
            this.loadinginbox = false;
          }

          

          //this.spinner.hide();
          this.isStart = false;
          //this.groupOptions = { columns: ['slaName'] };
          // this.loadKPINotification();
        },
          (error) => {
            //Called when error
            this.spinner.hide();
            
            this.loading = false;
            this.loadinginbox = false;
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();

        });
    }
  }
  loadKPIInboxCompleted() {
    
    let inpValue = new kpiInbox();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    //this.loading = true;
   // this.spinner.show();
    inpValue.slaUno = (this.filterSla_default > 0) ? this.filterSla_default : this.slaUno;
    inpValue.slaRuleUno = (this.filterFrequency_default > 0) ? this.filterFrequency_default : this.frequencyUno;
    inpValue.reportingDivisionUno = (this.filterDivision_default > 0) ? this.filterDivision_default : this.divisionUno;

    inpValue.currentYear = (this.filterYear_default > 0) ? this.filterYear_default : this.currentYear;
    inpValue.currentQuarter = (this.filterQuarter_default > 0) ? this.filterQuarter_default : this.currentQuarter;
    inpValue.currentMonth = this.currentMonth;
    inpValue.currentHalf = this.currentHalf;
    inpValue.filterDataCollection = this.filterDataCollection;
    inpValue.filterOverdue = this.filterOverdue;
    inpValue.filterApproval = this.filterApproval;
    inpValue.filterCompleted = this.filterCompleted;
    inpValue.filterColor = this.filterColor;
    inpValue.isAdmin = this.isAdmin;
    this.kpiInbox_data = [];
    this.selectedUserUno = 0;

    if (!this.loadinginbox) {

      this.dataSearch = [];
      this.datasetCompleted = [];     
      this.loadinginbox = true;
      this.restApi.getKpiInbox(inpValue)
        .subscribe(data => {
          try {

            
            let rtnData: any = data;
            this.kpiInbox_data = rtnData.data;
            
            const mockDataset = this.kpiInbox_data;

            

            setTimeout(() => {
              this.dataSearch = mockDataset;
              this.datasetCompleted = mockDataset;
              this.columnDefinitionsCompleted = [];


              if (mockDataset.length > 0) {
                this.setColnDefnCompleted();
              }
              this.loadinginbox = false;
              //Load More
              if (this.filterCompletedCount >= 500) {
                
                let loadComplete = new Promise((resolve, reject) => {
                  setTimeout(() => {
                  this.loadKPIInboxCompletedMore();
                    resolve('LOAD All');
                  }, 1000);

                });

                try {
                  let result = Promise.all([loadComplete]);
                  result.then(data => console.log(data));
                } catch (error) {
                  console.log(error);
                }
              }



              
              
            }, 200);

          } catch (e) {
            //this.spinner.hide();
            
            this.loading = false;
            this.loadinginbox = false;
          }

          

          //this.spinner.hide();
          this.isStart = false;
          //this.groupOptions = { columns: ['slaName'] };
          // this.loadKPINotification();
        },
          (error) => {
            //Called when error
            //this.spinner.hide();
            
           
            this.loadinginbox = false;
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();

        });
    }
  }

  loadKPIInboxCompletedMore() {

    let inpValue = new kpiInbox();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    //this.loading = true;
    // this.spinner.show();
    inpValue.slaUno = (this.filterSla_default > 0) ? this.filterSla_default : this.slaUno;
    inpValue.slaRuleUno = (this.filterFrequency_default > 0) ? this.filterFrequency_default : this.frequencyUno;
    inpValue.reportingDivisionUno = (this.filterDivision_default > 0) ? this.filterDivision_default : this.divisionUno;

    inpValue.currentYear = (this.filterYear_default > 0) ? this.filterYear_default : this.currentYear;
    inpValue.currentQuarter = (this.filterQuarter_default > 0) ? this.filterQuarter_default : this.currentQuarter;
    inpValue.currentMonth = this.currentMonth;
    inpValue.currentHalf = this.currentHalf;
    inpValue.filterDataCollection = this.filterDataCollection;
    inpValue.filterOverdue = this.filterOverdue;
    inpValue.filterApproval = this.filterApproval;
    inpValue.filterCompleted = this.filterCompleted;
    inpValue.filterColor = this.filterColor;
    inpValue.isAdmin = this.isAdmin;
    this.kpiInbox_data = [];
    this.selectedUserUno = 0;

    if (!this.loadinginbox) {

      //this.dataSearch = [];
      //this.datasetCompleted = [];
      //this.loadinginbox = true;
      this.restApi.getKpiInbox(inpValue)
        .subscribe(data => {
          try {


            let rtnData: any = data;
            this.kpiInbox_data = rtnData.data;

            const mockDataset = this.kpiInbox_data;



            setTimeout(() => {
              this.dataSearch = mockDataset;
              this.datasetCompleted = mockDataset;
              this.columnDefinitionsCompleted = [];


              if (mockDataset.length > 0) {
                this.setColnDefnCompleted();
              }

              //Load More
              //if (this.currentType != 'Approvals1') {
              //inpValue.condition = 4;
              //this.loadMoreKPIInbox(inpValue);
              //}



              //this.spinner.hide();

              this.loadinginbox = false;

            }, 200);

          } catch (e) {
            //this.spinner.hide();

            this.loading = false;
            this.loadinginbox = false;
          }



          //this.spinner.hide();
          this.isStart = false;
          //this.groupOptions = { columns: ['slaName'] };
          // this.loadKPINotification();
        },
          (error) => {
            //Called when error
            //this.spinner.hide();


            this.loadinginbox = false;
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();

        });
    }
  }

  //load kpi inbox count
  loadKPIInboxCount() {


    let inpValue = new kpiInbox();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = (this.filterSla_default > 0) ? this.filterSla_default : this.slaUno;
    inpValue.slaRuleUno = (this.filterFrequency_default > 0) ? this.filterFrequency_default : this.frequencyUno;
    inpValue.reportingDivisionUno = (this.filterDivision_default > 0) ? this.filterDivision_default : this.divisionUno;

    inpValue.currentYear = (this.filterYear_default > 0) ? this.filterYear_default : this.currentYear;
    inpValue.currentQuarter = (this.filterQuarter_default > 0) ? this.filterQuarter_default : this.currentQuarter;
    inpValue.currentMonth = this.currentMonth;
    inpValue.currentHalf = this.currentHalf;
    inpValue.filterDataCollection = this.filterDataCollection;
    inpValue.filterOverdue = this.filterOverdue;
    inpValue.filterApproval = this.filterApproval;
    inpValue.filterCompleted = this.filterCompleted;
    inpValue.isAdmin = this.isAdmin;
    
    this.restApi.getKpiInboxCount(inpValue)
      .subscribe(data => {

        let rtnData: any = data;
        //this.kpiInbox_data_count = data[0];
        this.filterDataCollectionCount = rtnData.data[0].filterDataCollectionCount;
        this.filterCompletedCount = rtnData.data[0].filterCompletedCount;
        this.filterApprovalCount = rtnData.data[0].filterApprovalCount;
        this.filterOverdueCount = rtnData.data[0].filterOverdueCount;
        this.userService.refreshLeftNavCount(this.filterDataCollectionCount, this.filterApprovalCount, this.filterCompletedCount);
        

      },
        (error) => {
          //Called when error
          //this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }


  viewKPI(kpiTrnUno: any) {

    this.router.navigateByUrl('/kpiview/' + kpiTrnUno);
  }

  //To view the selected KPI comment values
  viewKPIComment(kpiTrnUno: any) {
    this.spinner.show();
    this.enableHisGrid = true;
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiViewComments(inpValue)
      .subscribe(data => {

        let objData: any = data;
        if (this.commentStartIndex == 1) {
          this.kpiViewComment_data = [];
          this.kpiViewComment_data = objData;

        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewComment_data.push(objData[i]);
          }
        }
        //if the result set is lessthen 10 then disable the load more icon
        this.disableMore = (objData.length >= 5) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.commentStartIndex = this.commentStartIndex + 1;
        }

        this.viewKPIIssue(kpiTrnUno);
        this.viewKPIJustification(kpiTrnUno);

        
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  //Get the KPI issues and list
  viewKPIIssue(kpiTrnUno: any) {
    this.datasetIssues = [];
    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiViewIssue(inpValue)
      .subscribe(data => {

        if (data != null && data != undefined) {
          this.kpiViewIssue_data = data;
          const mockDataset = [];
          for (let i = 0; i < this.kpiViewIssue_data.length; i++) {
            mockDataset[i] = {
              id: i + 1,
              postedBy: this.kpiViewIssue_data[i].postedBy,
              postedDate: this.kpiViewIssue_data[i].postedDate,
              comment: this.kpiViewIssue_data[i].comment,
            };
          }
          this.datasetIssues = mockDataset;
      
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get and load the KPI Justificaiton
  viewKPIJustification(kpiTrnUno: any) {
    this.datasetComments = [];
    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiViewJustification(inpValue)
      .subscribe(data => {

        if (data != null && data != undefined) {
          this.kpiViewJustification_data = data;
          const mockDataset = [];
          for (let i = 0; i < this.kpiViewJustification_data.length; i++) {
            mockDataset[i] = {
              id: i+1,
              action: this.kpiViewJustification_data[i].action,
              postedBy: this.kpiViewJustification_data[i].postedBy,
              postedDate: this.kpiViewJustification_data[i].postedDate,
              comment: this.kpiViewJustification_data[i].comment,
            };
          }
          this.datasetComments = mockDataset;
          this.setCommentDefn();
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  showCommentDialog(kpiTrnUno: any, kpiNameEn: any) {
    this.kpiViewComment_data = [];
    this.kpiViewIssue_data = [];
    this.kpiViewJustification_data = [];
    this.kpiTrnUno_poped = kpiTrnUno;
    this.viewKPIComment(kpiTrnUno);
    this.kpiViewComment_data = [];
    this.kpinameSelected = kpiNameEn;
    this.commentStartIndex == 1;
    this.modalRef = this.modalService.show(
      this.CommentDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  getMoreComment() {
    this.viewKPIComment(this.kpiTrnUno_poped);
  }
  openApproveDialog() {
    if (this.objkpiInbox_selecteddata.objkpiViewWorkflow.length <= 0) return false;
    this.approveComment = '';
    this.kpinameSelected = "Multiple";

    this.modalRef = this.modalService.show(
      this.ApproveDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  showApproveDialog(kpidata: any) {
    this.approveComment = '';
    this.objkpiInbox_selecteddata = new kpiViewWorkFlow();
    let objKR = new kpiViewWorkFlow();
    let objitem: any = kpidata;

    this.kpinameSelected = objitem.kpiCode;//objitem.kpiCode + " : " + objitem.kpiNameEn;
    //Get The level
    let cLevel = this.getCurrentLevel(kpidata);
    if (cLevel == 1) {
      objitem.action = 'Level 1';
    }
    else if (cLevel == 2) {
      objitem.action = 'Level 2';
    }
    else if (cLevel == 3) {
      objitem.action = 'Level 3';
    }
    objitem.condition = cLevel;

    objKR = objitem;
    objKR.tenantUno = 1;


    this.objkpiInbox_selecteddata.objkpiViewWorkflow.push(objKR);

    this.modalRef = this.modalService.show(
      this.ApproveDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  openRejectDialog() {
    this.rejectComment = '';
    this.txtRejectError = '';
    this.isRejectError = false;
    this.kpinameSelected = 'Multiple'
    if (this.objkpiInbox_selecteddata.objkpiViewWorkflow.length <= 0) return false;
    this.objkpiInbox_selecteddata.objkpiViewWorkflow.forEach(function (obitem) {
      obitem.condition = 5;
    });
    this.modalRef = this.modalService.show(
      this.RejectDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

  }
  showRejectDialog(kpidata: any) {
    this.rejectComment = '';
    this.txtRejectError = '';
    this.isRejectError = false;
    this.objkpiInbox_selecteddata = new kpiViewWorkFlow();
    let objKR = new kpiViewWorkFlow();
    let objitem: any = kpidata;

    this.kpinameSelected = objitem.kpiCode + " : " + objitem.kpiNameEn;
    //Get The level
    let cLevel = this.getCurrentLevel(kpidata);
    if (cLevel == 1) {
      objitem.action = 'Level 1';
    }
    else if (cLevel == 2) {
      objitem.action = 'Level 2';
    }
    else if (cLevel == 3) {
      objitem.action = 'Level 3';
    }
    objitem.condition = cLevel + 3;

    objKR = objitem;
    objKR.tenantUno = 1;
    this.objkpiInbox_selecteddata.objkpiViewWorkflow.push(objKR);

    this.modalRef = this.modalService.show(
      this.RejectDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  onSubmitApprove() {
    //this.checkCurrentUserAndLevel(this.objkpiInbox_selecteddata.objkpiInbox);
    //if (this.isCurrentLevelUser) {

    this.onApproveRejectSubmit('Approved');
    // }
  }
  onSubmitReject() {
    // this.checkCurrentUserAndLevel(this.objkpiInbox_selecteddata.objkpiInbox);
    // if (this.isCurrentLevelUser) {
    this.onApproveRejectSubmit('Rejected');
    //}

  }
  DataEntryKPI(objData: any, type: string) {
    
    this.txtDataEntryError = ''
    this.isDataEntryError = false;
    this.kpiTrnUno = objData.kpiTrnUno;
    this.kpiViewBand_data = new kpiband();
    this.formInit();
    this.kpinameSelected = objData.kpiCode;//objData.kpiCode + " : " + objData.kpiNameEn;
    this.NANRVal = '';
    this.strkpiname = objData.kpiNameEn;
    this.loadKPICodeDetails(objData.kpiTrnUno, type);
  }
  //Get KPI Code Details
  loadKPICodeDetails(kpiTrnUno: number, type: string) {
    
    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.NANRVal = '';
    this.restApi.getKpiCodeDetails(inpValue)
      .subscribe(data => {

        //this.data = data;
        if (data != null && data != undefined) {
          if (type == 'dataentry') {
            this.modalRef = this.modalService.show(
              this.KPIDataEntryDialog,
              Object.assign({}, {
                class: 'gray modal-medium',
                backdrop: true,
                keyboard: true,
                focus: true,
                show: false,
                ignoreBackdropClick: true,
                animated: true
              })
            );
            this.kpiRuleForm.get('enteredTargetValue').enable();
            this.kpiRuleForm.get('selectPassFail').enable();
          }

          //this.kpiCodeDetail = new kpiInbox();
          this.kpiCodeDetail = data[0];
          if (this.kpiCodeDetail != null && this.kpiCodeDetail.dataOwnerActionBy == '') {
            this.NANRVal = '';
            this.actualTargetValue = parseFloat(this.kpiCodeDetail.actualValue != '' ? this.kpiCodeDetail.actualValue : '0');
            this.actualTrend = this.kpiCodeDetail.trendUno;
            this.kpiRuleForm.setValue({
              enteredTargetValue: this.kpiCodeDetail.targetValue,
              cmntApproval: this.kpiCodeDetail.dataOwnerComments,
              justification: this.kpiCodeDetail.justificationText,
              selectNANR: (this.kpiCodeDetail.isNANRNT == 'NA' ? true : false),
              selectPassFail: this.kpiCodeDetail.passFail
            });
            if (this.kpiCodeDetail.isNANRNT == 'NA') {
              this.kpiRuleForm.get('enteredTargetValue').reset();
              this.kpiRuleForm.get('enteredTargetValue').disable();

              this.kpiRuleForm.get('selectPassFail').reset();
              this.kpiRuleForm.get('selectPassFail').disable();
              this.NANRVal = 'NA';
              this.band_calculated = 'gray-bar';
            }
            if (this.kpiCodeDetail.bandColour != '') {
              this.band_calculated = (this.kpiCodeDetail.bandColour == 'Red') ? 'red-bar' :
                (this.kpiCodeDetail.bandColour == 'Orange') ? 'orange-bar' :
                  (this.kpiCodeDetail.bandColour == 'Yellow') ? 'yellow-bar' :
                    (this.kpiCodeDetail.bandColour == 'Light Green') ? 'light-green-bar' : (this.kpiCodeDetail.bandColour == 'Green') ? 'green-bar' : 'gray-bar';
            }
            else {
              this.band_calculated = 'gray-bar';
            }
          }
          this.loadKPIDynamicTransaction(this.kpiTrnUno);
         
          this.loadKPIViewBand(this.kpiCodeDetail.kpiUno, this.kpiCodeDetail.kpiYear, this.kpiCodeDetail.scheduleUno, this.kpiCodeDetail.bandScheduleTypeUno, type);

          this.kpiUnoSelected = data[0].kpiUno;
          //this.scheduleUno_gloabl = data[0].scheduleUno;
          //this.getSchduleTypeNo();
          //this.actualTargetValue = (this.kpiCodeDetail.actualValue != null && this.kpiCodeDetail.actualValue != '') ? parseInt(this.kpiCodeDetail.actualValue) : 0;
          //this.checkCurrentUserAndLevel(data);
          //if (this.kpiCodeDetail.justificationText == '' || this.kpiCodeDetail.justificationText == null) {
          //  this.kpiRuleForm.get('justification').reset();
          //  this.kpiRuleForm.get('justification').disable();
          //}
          //else {
          //  this.kpiRuleForm.get('justification').enable();
          //}

        }

        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Get KPI Band
  loadKPIViewBand(kpiUno: number, defaultyear: number, scheduleUno: number, bandScheduleTypeUno: number, type: string) {

    this.spinner.show();
    let inpValue = new kpiband();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = defaultyear;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.scheduleUno = scheduleUno;
    inpValue.scheduleTypeUno = bandScheduleTypeUno;
    this.restApi.getkpiViewBand(inpValue)
      .subscribe(data => {
        this.kpiViewBand_data = data[0];

        if (type == 'dataentryapproval') {
          setTimeout(() => { this.onSubmit(this.kpiCodeDetail.slaRuleUno, 'submit'); }, 500);
        }

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //Submit the KPI inbox seelcted row values and validation
  onSubmit(slaRuleUno: number, type: string) {
    

    this.isDataEntryError = false;
    this.txtDataEntryError = '';
    let selectNANR = null;
    let comment = '';
    let jsutification = '';
    let targetEnValue = 0;
    let passfail = '';
    //Get Selected Vlaues
    selectNANR = (this.NANRVal == null || this.NANRVal == undefined || this.NANRVal == '') ? '' : 'NA';
    let objTargetEnValue = this.kpiRuleForm.get('enteredTargetValue').value;
    jsutification = this.kpiRuleForm.get('justification').value;
    comment = this.kpiRuleForm.get('cmntApproval').value;

    //Set Target if Rule is text [Pass--100 / Fail --0]
    if (slaRuleUno == 4) {

      passfail = (this.kpiRuleForm.get('selectPassFail') != null) ? this.kpiRuleForm.get('selectPassFail').value : '';
      if (selectNANR != 'NA') {
        if (passfail == undefined || passfail == null || passfail == '') {
          //Swal.fire('Error', 'Please Select Pass/Fail', 'error');
          this.txtDataEntryError = 'Please Select Pass/Fail';
          this.isDataEntryError = true;
          return false;
        }
        if (passfail == 'Fail') { //this.NANRVal != '' ||
          if (jsutification == null || jsutification.trim() == '') {
            //Swal.fire('Error', 'Please Enter Approver Comment', 'error')
            this.txtDataEntryError = 'Please Enter Justification';
            this.isDataEntryError = true;
            //this.kpiRuleForm.get('justification').enable();
            return false;
          }
        }
      }




    }

    //Target Value validation
    targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseFloat(objTargetEnValue) : 0;
    //if ((this.txtTarget.value == null || this.txtTarget.value.toString() == '' || objTargetEnValue == null || objTargetEnValue == '') && selectNANR == '') {
    if (targetEnValue == 0 && selectNANR == '' && (slaRuleUno == 1 || slaRuleUno == 2)) {
      //Swal.fire('Error', 'Please Enter the Actual Value', 'error');
      //return false;
      targetEnValue = 0;
    }



    //Comment require 

    let objKPIView = new kpiViewWorkFlow();
    objKPIView.action = 'Send for Approval by Data Owner';
    objKPIView.selectedNANR = this.NANRVal;
    objKPIView.kpiTrnUno = this.kpiTrnUno;
    objKPIView.comment = (comment == null || comment == undefined) ? '' : comment;
    objKPIView.justification = (jsutification == null || jsutification == undefined) ? '' : jsutification;
    objKPIView.userUno = this.login_UserID;
    objKPIView.passFail = passfail;
    objKPIView.targetEnteredValue = targetEnValue;
    objKPIView.condition = 0;//(this.pageAction == "add") ? 0 : 1;
    objKPIView.saveAction = type;

    
    if (slaRuleUno == 1 || slaRuleUno == 2 || slaRuleUno == 3) {


      let classname: string = '';
      let band1Value1 = this.kpiViewBand_data.band1Value1;
      let band2Value1 = this.kpiViewBand_data.band2Value1;
      let band3Value1 = this.kpiViewBand_data.band3Value1;
      let band4Value1 = this.kpiViewBand_data.band4Value1;
      let band5Value1 = this.kpiViewBand_data.band5Value1;
      let band1Condition1 = this.kpiViewBand_data.band1Condition1;
      let band2Condition1 = this.kpiViewBand_data.band2Condition1;

      if (targetEnValue > this.actualTargetValue) {
        // Swal.fire('Error', ' Actual Value should <=' + this.actualTargetValue, 'error')
        // this.txtDataEntryError = 'Actual Value should <=' + this.actualTargetValue;
        // this.isDataEntryError = true;
        // classname = '';
        //return false;
      }
      let bandfinalcolor = '';
      if (this.NANRVal == '') {
        classname = this.getBadcolorFinal(slaRuleUno, targetEnValue, band1Value1, band2Value1, band3Value1, band4Value1, band5Value1, band1Condition1, band2Condition1);
        if (classname == '') { this.band_calculated = 'gray-bar'; return false; } else { this.band_calculated = classname; }

      }

      //Comment require
      if (this.NANRVal == '' && this.getWellPerform(slaRuleUno, classname) == 0) {

        if (objKPIView.justification == null || objKPIView.justification.trim() == '') {
          //  Swal.fire('Error', 'Please Enter Approver Comments', 'error')
          this.txtDataEntryError = 'Under Performed KPI: Please Enter Justification';
          this.isDataEntryError = true;
          //this.kpiRuleForm.get('justification').enable();
          return false;
        }
      }


      if (this.NANRVal == '') {
        if (classname == 'red-bar') {
          objKPIView.bandColorFinal = 'Red';
        }
        else if (classname == 'orange-bar') {
          objKPIView.bandColorFinal = 'Orange';
        }
        else if (classname == 'yellow-bar') {
          objKPIView.bandColorFinal = 'Yellow';
        }
        else if (classname == 'light-green-bar') {
          objKPIView.bandColorFinal = 'Light Green';
        }
        else if (classname == 'green-bar') {
          objKPIView.bandColorFinal = 'Green';
        }
      }
      else {
        this.band_calculated = 'gray-bar';
      }

      if (type == 'submit') {

        if (this.checkEntryLabelValidation()) {
          Swal.fire('Error', 'Please enter all entry fileds.', 'error')
          return false;
        }
        if (this.modalRef && this.modalRef.content)
          this.modalRef.hide();
        let htmldisplay = (this.NANRVal == '') ? '<div> <table class="table table-bordered"><tr><td> Performance:</td><td> <span class="' + classname + '" style="marin:auto"></span></td></table></div>' :
          '<div> <table class="table"><tr><td> Performance: </td><td> <span style="marin:auto">NA</span></td></table></div>';
        Swal.fire({
          title: 'Please Confirm to Send for Approval',
          html: htmldisplay,
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.value) {

            objKPIView.isWellPerformed = this.getWellPerform(slaRuleUno, classname);
            this.CallUpdate(objKPIView);

            return;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        })
      }
      else {
        objKPIView.isWellPerformed = this.getWellPerform(slaRuleUno, classname);
        this.CallUpdate(objKPIView);
      }
    }
    else {
      if (type == 'submit') {
        this.modalRef.hide();
        let classname = (passfail != '' && passfail == 'Pass') ? 'green-bar' : 'red-bar'
        Swal.fire({
          title: 'Please Confirm to Send for Approval',
          html:
            (this.NANRVal == '') ? '<div style="padding-left:115px"> <table class="table" style="border:none"><tr><td width="10%"> Performance:</td><td> <span class="' + classname + '" style="position:inherit!important"></span></td></table></div>' :
              '<div style="padding-left:115px"> <table class="table" style="border:none"><tr><td width="10%"> Performance:</td><td> <span style="position:inherit!important">NA</span></td></table></div>',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.value) {
            if (this.NANRVal == '') {
              objKPIView.bandColorFinal = (passfail != '' && passfail == 'Pass') ? 'Green' : 'Red';
              objKPIView.isWellPerformed = (passfail != '' && passfail == 'Pass') ? 1 : 0;
            }
            this.CallUpdate(objKPIView);
            return;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        })
      }
      else {
        if (this.NANRVal == '') {
          objKPIView.bandColorFinal = (passfail != '' && passfail == 'Pass') ? 'Green' : 'Red';
          objKPIView.isWellPerformed = (passfail != '' && passfail == 'Pass') ? 1 : 0;
        }
        this.CallUpdate(objKPIView);
      }


    }

    return true;

  }
  checkEntryLabelValidation() {
    
    let isEmpty = false;
    if (this.dynamicBinding_data.length > 0) {
      for (var i = 0; i < this.dynamicBinding_data.length; i++) {
        let txtvalue: any = document.getElementById('txtValue_' + i) as HTMLInputElement;

        if (txtvalue.value == '') {
          isEmpty = true;
          break;
        }
      }
    }
    return isEmpty;
  }


  showKPIBand() {
    this.modalInfoRef = this.modalService.show(
      this.BandDialog,
      Object.assign({}, {
        class: 'gray modal-medium-sm',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  onchangePassFail(e: any) {
    let passfail = (e.itemData != null) ? e.itemData.value : '';
    if (passfail != '') {
      this.band_calculated = (passfail == 'Fail') ? "red-bar" : "green-bar";
    }

  }
  GetBandColorClass(slaRuleUno: number) {
    
    let targetEnValue = 0;
    //Get Selected Vlaues
    let selectNANR = (this.NANRVal == null || this.NANRVal == undefined) ? '' : this.NANRVal;
    if (selectNANR == '') {


      let objTargetEnValue = this.kpiRuleForm.get('enteredTargetValue').value;
      //Target Value validation
      if ((objTargetEnValue == null || objTargetEnValue == '') && selectNANR == '') {
        //  Swal.fire('Error', 'Please Enter the Actual value', 'error')
        //  return false;
      }
      targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseFloat(objTargetEnValue) : 0;

      //0-Target Class Get
      if (slaRuleUno == 3) {
        this.band_calculated = (targetEnValue == 0) ? "green-bar" : "red-bar";
        return true;
      }

      //Pas/Fail Class Get
      if (slaRuleUno == 4) {
        let passfail = (this.kpiRuleForm.get('selectPassFail') != null) ? this.kpiRuleForm.get('selectPassFail').value : '';
        if (passfail == '') {
          //Swal.fire('Error', 'Please Select the option Pass/Fail', 'error')
          this.txtDataEntryError = 'Please Select the option Pass/Fail';
          this.isDataEntryError = true;
          return false;
        }

        this.band_calculated = (passfail == 'Fail') ? "red-bar" : "green-bar";
        return true;
      }

      //Other Types Class Get

      if (targetEnValue > this.actualTargetValue) {
        //Swal.fire('Error', ' Actual Value should <=' + this.actualTargetValue, 'error')
        //return false;
        //Swal.fire('Error', 'Please Select the option Pass/Fail', 'error')
        //this.txtDataEntryError = 'Actual Value should <=' + this.actualTargetValue;
        //this.isDataEntryError = true;
        //return false;
      }
      this.band_calculated = '';
      let band1Value1 = this.kpiViewBand_data.band1Value1;
      let band2Value1 = this.kpiViewBand_data.band2Value1;
      let band3Value1 = this.kpiViewBand_data.band3Value1;
      let band4Value1 = this.kpiViewBand_data.band4Value1;
      let band5Value1 = this.kpiViewBand_data.band5Value1;

      let band1Condition1 = this.kpiViewBand_data.band1Condition1;
      let band2Condition1 = this.kpiViewBand_data.band2Condition1;

      let classname = this.getBadcolorFinal(slaRuleUno, targetEnValue, band1Value1, band2Value1, band3Value1, band4Value1, band5Value1, band1Condition1, band2Condition1);
      if (classname == '') { this.band_calculated = 'gray-bar'; return false; } else { this.band_calculated = classname; }

      //if (this.band_calculated == 'red-bar') {
      //  this.kpiRuleForm.get('justification').enable();
      //}
      //else {
      //  this.kpiRuleForm.get('justification').reset();
      //  this.kpiRuleForm.get('justification').disable();
      //}

    }
    else {
      this.band_calculated = 'gray-bar';
    }

  }

  getBadcolorFinal(slaRuleUno: any, targetEnValue: any, band1Value1: number, band2Value1: number, band3Value1: number, band4Value1: number, band5Value1: number, band1Condition1: number, band2Condition1: number) {


    let classname: string = '';
    let targetEnValue_tmp = targetEnValue;
    if ((this.kpiViewBand_data.bandtype == 2)) {

      targetEnValue_tmp = ((targetEnValue / this.actualTargetValue) * 100).toFixed();

    }
    if (slaRuleUno == 2) {

      let tr = (this.actualTrend == "1") ? 1 : -1;
      targetEnValue_tmp = (((targetEnValue - this.actualTargetValue) * tr) / this.actualTargetValue) * 100;
      targetEnValue_tmp = (targetEnValue_tmp > 100) ? 100 : targetEnValue_tmp;
    }
    if (slaRuleUno == 11) {


      if (targetEnValue_tmp <= band1Value1) {
        classname = "red-bar";
      }
      else if ((targetEnValue_tmp >= band1Value1) && (targetEnValue_tmp <= band2Value1)) {

        classname = "red-bar";
      }
      else if ((targetEnValue_tmp >= band2Value1) && (targetEnValue_tmp <= band3Value1)) {

        classname = "orange-bar";
      }
      else if ((targetEnValue_tmp >= band3Value1) && (targetEnValue_tmp <= band4Value1)) {

        classname = "yellow-bar";
      }
      else if ((targetEnValue_tmp >= band4Value1) && (targetEnValue_tmp < band5Value1)) {

        classname = "light-green-bar";
      }
      else if (targetEnValue_tmp >= band5Value1) {

        classname = "green-bar";
      }
    }
    else if (slaRuleUno == 2 || slaRuleUno == 1) {



      //if (targetEnValue_tmp <= band1Value1) {
      //  classname = "red-bar";
      //}
      //else if ((targetEnValue_tmp >= band1Value1) && (targetEnValue_tmp <= band2Value1)) {

      //  classname = "green-bar";
      //}
      //else if (targetEnValue_tmp > band2Value1) {

      //  classname = "green-bar";
      //}

      if (
        (targetEnValue_tmp > band1Value1 && band1Condition1 == 1) || //conditon type >
        (targetEnValue_tmp >= band1Value1 && band1Condition1 == 2) || //conditon type >=
        (targetEnValue_tmp == band1Value1 && band1Condition1 == 3) || //conditon type ==
        (targetEnValue_tmp < band1Value1 && band1Condition1 == 4) || //conditon type <
        (targetEnValue_tmp <= band1Value1 && band1Condition1 == 5)  //conditon type <=
      ) {
        classname = "red-bar";
      }
      if (
        (targetEnValue_tmp > band2Value1 && band2Condition1 == 1) || //conditon type >
        (targetEnValue_tmp >= band2Value1 && band2Condition1 == 2) || //conditon type >=
        (targetEnValue_tmp == band2Value1 && band2Condition1 == 3) || //conditon type ==
        (targetEnValue_tmp < band2Value1 && band2Condition1 == 4) || //conditon type <
        (targetEnValue_tmp <= band2Value1 && band2Condition1 == 5)  //conditon type <=
      ) {
        classname = "green-bar";
      }
      //entered value is greater than the target value then passed as green (Well performed) -- when performance is empty
      if (classname == '') {
        if (targetEnValue >= this.actualTargetValue)
          classname = "green-bar";
        else {
          //this.toaster.show('error', 'Error', 'Something went wrong in the KPI Band value configuration.');
        }
      }


    }
    else if (slaRuleUno == 3) {


      if (targetEnValue_tmp == 0) {
        classname = "green-bar";
      }
      else {

        classname = "red-bar";
      }

    }

    return classname;
  }

  getWellPerform(slaRuleUno: any, classname: string) {

    let rtnValue: number = 0;
    if (slaRuleUno == 11) {
      if (classname == 'red-bar') {
        rtnValue = (this.kpiViewBand_data.band1wellperform) ? 1 : 0;
      }
      else if (classname == 'orange-bar') {
        rtnValue = (this.kpiViewBand_data.band2wellperform) ? 1 : 0;
      }
      else if (classname == 'yellow-bar') {
        rtnValue = (this.kpiViewBand_data.band3wellperform) ? 1 : 0;
      }
      else if (classname == 'light-green-bar') {
        rtnValue = (this.kpiViewBand_data.band4wellperform) ? 1 : 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = (this.kpiViewBand_data.band5wellperform) ? 1 : 0;
      }
    }
    if (slaRuleUno == 2 || slaRuleUno == 1) {
      if (classname == 'red-bar') {
        rtnValue = (this.kpiViewBand_data.band1wellperform) ? 1 : 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = (this.kpiViewBand_data.band2wellperform) ? 1 : 0;
      }
    }

    if (slaRuleUno == 3) {
      if (classname == 'red-bar') {
        rtnValue = 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = 1;
      }
    }
    return rtnValue;
  }

  CallUpdate(objKPIView: kpiViewWorkFlow) {
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      //Check file count 
      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload.');
        return false;
      }

      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        if (!this.userService.checkFileSize(fileSize)) {
          this.toaster.show('error', 'Error', 'General Information - A file size should not above 30MB.');
          return false;
        }
        //To check file exe
        if (!this.userService.checkFileValuranabity(fileName, fileSize)) {
          this.toaster.show('error', 'Error', 'General Information - Please select the correct format file.');
          return false;
        }
      }
    }
    objKPIView.tenantUno = this.tenantUno;
    objKPIView.dataOwnerUno = this.kpiCodeDetail.dataOwnerActionByUno.toString();
    objKPIView.level1ApproverUno = this.kpiCodeDetail.level1ApproverUno;
    objKPIView.level2ApproverUno = this.kpiCodeDetail.level2ApproverUno;
    objKPIView.level3ApproverUno = this.kpiCodeDetail.level3ApproverUno;
    objKPIView.kpiYear = this.kpiCodeDetail.kpiYear;
    objKPIView.kpiQuarter = this.kpiCodeDetail.kpiQuarter;
    objKPIView.kpiUno = this.kpiCodeDetail.kpiUno;
    objKPIView.kpiNameEn = this.kpiCodeDetail.kpiNameEn;
    objKPIView.kpiYearName = this.kpiCodeDetail.kpiYearName;
    objKPIView.kpiQuarterName = this.kpiCodeDetail.kpiQuarterName;
    var tval = (this.kpiCodeDetail.actualValue != null && this.kpiCodeDetail.actualValue != '' && this.kpiCodeDetail.actualValue != undefined) ? parseInt(this.kpiCodeDetail.actualValue) : 0;
    objKPIView.targetValue = tval;

    objKPIView.actualTargetValue = this.kpiCodeDetail.actualTargetValue;
    objKPIView.targetValueText = tval.toString();
    objKPIView.actualValueText = objKPIView.targetEnteredValue.toString();

    //XML Value For KPI Dynamic Transaction
    
    if (this.dynamicBinding_data.length > 0) {
      let strXmlValue = '<roots>';
      for (var i = 0; i < this.dynamicBinding_data.length; i++) {

        let txtvalue: any = document.getElementById('txtValue_' + i) as HTMLInputElement;
        strXmlValue += "<root>";
        strXmlValue += "<KPIDynamicLabel>" + this.dynamicBinding_data[i].label + "</KPIDynamicLabel>";
        strXmlValue += "<KPIDynamicValue>" + txtvalue.value + "</KPIDynamicValue>";
        strXmlValue += "<KPIUno>" + objKPIView.kpiUno + "</KPIUno>";
        strXmlValue += "<Year>" + objKPIView.kpiYear + "</Year>";
        strXmlValue += "<Quarter>" + objKPIView.kpiQuarter + "</Quarter>";
        strXmlValue += "<TenantUno>" + objKPIView.tenantUno + "</TenantUno>";
        strXmlValue += "</root>";
      }
      strXmlValue += '</roots>';
      
      objKPIView.xmlValue = strXmlValue;
    }
    else {
      objKPIView.xmlValue = "";
    }

    
    //setTimeout(function () {
      
    //}, 500)
    this.restApi.addKpiViewWorkflow(objKPIView)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Saved Successfully',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.uploadFiles();
          this.toaster.show('success', 'Success', 'KPI Saved Successfully');
          this.kpiRuleForm.reset();

        }

        this.modalRef.hide();
        this.spinner.hide();
        this.loadInboxDefaults();
        
      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.modalRef.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
        //  this.KPIDataEntryDialog.show();
      });
    return true;
  }

  onchangeNANR(e) {
    
    this.NANRVal = '';
    if (e != null && e) { //if (e != null && e.target.checked) {
      this.NANRVal = 'NA';
      this.kpiRuleForm.get('enteredTargetValue').reset();
      this.kpiRuleForm.get('enteredTargetValue').disable();

      this.kpiRuleForm.get('selectPassFail').reset();
      this.kpiRuleForm.get('selectPassFail').disable();

      this.band_calculated = 'gray-bar';

    }
    else {
      this.NANRVal = '';
      this.kpiRuleForm.get('enteredTargetValue').enable();
      this.kpiRuleForm.get('selectPassFail').enable();
    }
  }


  checkCurrentUserAndLevel(data: any) {

    this.currentLevelUser = '';
    this.currentLevel = 0;
    this.isCurrentLevelUser = false;
    //checking Current level

    this.currentLevel = this.getCurrentLevel(data);
    this.currentLevelUser = this.getCurrentLevelUser(data);

    //Checking whether loggged user and current level user same or not
    //this.kpiCodeDetail.currentLevel = currentLevel;

    //currentLevelUser = "2,3";
    let login_UserID = this.RASHelper.decryptWithPrivateKey(this.login_UserID.toString());
    if (this.currentLevelUser.toString().indexOf(',') > -1) {
      let userArr = this.currentLevelUser.toString().split(',');
      for (let num of userArr) {
        if (login_UserID.toString() == num) {
          this.isCurrentLevelUser = true;
        }
      }
    }
    else {
      if (login_UserID.toString() == this.currentLevelUser.toString()) {
        this.isCurrentLevelUser = true;
      }
    }
    if (this.isAdmin) { this.isCurrentLevelUser = true; }
    return this.isCurrentLevelUser;
  }

  getCurrentLevel(data: any) {
    //currentLevel 0 - Data Entry
    //currentLevel 1 - Level 1 
    //currentLevel 2 - Level 2 
    //currentLevel 3 - Level 3
    let dataEntry = data.dataOwnerActionBy;
    let level1Approved = data.level1Approved;
    let level2Approved = data.level2Approved;
    let level3Approved = data.level3Approved;

    if (dataEntry == "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      return 0;
    }
    else if (dataEntry != "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      return 1;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 0 && level3Approved == 0) {
      return 2;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 1 && level3Approved == 0) {
      return 3;
    }
    if (level1Approved == 1 && level2Approved == 1 && level3Approved == 1) {
      return 7;
    }

  }
  getCurrentLevelUser(data: any) {
    //currentLevel 0 - Data Entry
    //currentLevel 1 - Level 1 
    //currentLevel 2 - Level 2 
    //currentLevel 3 - Level 3
    let dataEntry = data.dataOwnerActionBy;
    let level1Approved = data.level1Approved;
    let level2Approved = data.level2Approved;
    let level3Approved = data.level3Approved;

    if (dataEntry == "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      return data.dataOwnerUno;
    }
    else if (dataEntry != "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      return data.level1ApproverUno;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 0 && level3Approved == 0) {
      return data.level2ApproverUno;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 1 && level3Approved == 0) {
      return data.level3ApproverUno;
    }
    if (level1Approved == 1 && level2Approved == 1 && level3Approved == 1) {
      return "";
    }

  }

  onApproveRejectSubmit(type: string) {
    
    if (this.objkpiInbox_selecteddata.objkpiViewWorkflow.length <= 0) return false;

    let objKPIView = new kpiViewWorkFlow();

    let selectedData: any = this.objkpiInbox_selecteddata.objkpiViewWorkflow;
    objKPIView.userUno = this.login_UserID;
    objKPIView.actionType = type;
    //objKPIView.tenantUno = 1;
    objKPIView.tenantUno = this.tenantUno;
    objKPIView.saveAction = 'submit';
    objKPIView.objkpiViewWorkflow = this.objkpiInbox_selecteddata.objkpiViewWorkflow;
    objKPIView.targetValueText = selectedData.actualValueText;
    objKPIView.actualValueText = selectedData.targetValueText;
    objKPIView.passFail = selectedData.passFail;
    objKPIView.isNANRNT = selectedData.selectedNANR;

    this.selectedUserUno = 0;
    if (type == 'Approved') {
      let comment = this.approveComment;
      objKPIView.comment = comment;
      this.submitApproveReject(objKPIView, type);
    }
    else {
      let comment = this.rejectComment;
      objKPIView.comment = comment;
      if (comment == null || comment.trim() == '') {
        //Swal.fire('Error', 'Please Enter Comment', 'error')     
        this.txtRejectError = 'Please Enter Comment';
        this.isRejectError = true;
        return false;
      } else {
        this.modalRef.hide();
        //Swal.fire({
        //  title: '',
        //  text: 'Please Confirm to Reject the KPI',
        //  type: 'warning',
        //  showCancelButton: true,
        //  confirmButtonText: 'Ok',
        //  cancelButtonText: 'Cancel'
        //}).then((result) => {
        //  if (result.value) {

        //    // objKPIView.condition = (objKPIView.condition) + 3;
        //    this.txtRejectError = ''
        //    this.isRejectError = false;
        //    this.submitApproveReject(objKPIView, type);
        //    return;
        //  } else if (result.dismiss === Swal.DismissReason.cancel) {
        //    this.txtRejectError = ''
        //    this.isRejectError = false;
        //    return;
        //  }
        //})
        this.txtRejectError = ''
        this.isRejectError = false;
        this.submitApproveReject(objKPIView, type);
      }


    }
    return true;
  }


  submitApproveReject(objKPIView: any, type: string) {
    if (type == 'Approved') { this.modalRef.hide(); }
    else { this.modalRef.hide(); }
    objKPIView.saveAction = 'submit';


    this.restApi.bulkUpdateKpiViewWorkflow(objKPIView)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI ' + type,
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.toaster.show('success', 'Success', 'KPI ' + type);
          this.isRowSelected = false;
        }
        this.approveComment = '';
        this.rejectComment = '';
        this.spinner.hide();
        this.loadInboxDefaults();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  // Choose city using select dropdown
  onchangeSLA(e) {

    //alert(e.itemData.slaUno);
    this.slaUno = (e && e.length > 0) ? e[0].value : 0;
    this.filterSla_default = this.slaUno;
    this.storeFilterValues();
    if (!this.isStart) {
      this.loadInboxDefaults();
    }

  }

  onchangeUser(e) {
    
    //if (!this.isStart) {
    //  this.loadKPIInbox();
    //  this.loadKPIInboxCount();
    //}
    this.loading = true;
    this.loadinginbox = true;
    let selectedUser = (e && e.length > 0) ? e[0].value : 0;
    if (selectedUser > 0) {
      let filterKPIData: any;


      if (this.currentType == 'Data Entry') {
        filterKPIData = this.kpiInbox_data.filter(x => x.dataOwnerUno.split(",").includes(selectedUser.toString()));

        this.filterDataCollectionCount = filterKPIData.length;
      }

      if (this.currentType == 'Approvals') {
        filterKPIData = this.kpiInbox_data.filter(
          x => (((x.level1ApproverUno.split(",").includes(selectedUser.toString())) && (x.statusUno==1)) ||
            ((x.level2ApproverUno.split(",").includes(selectedUser.toString())) && (x.statusUno == 2))||
            ((x.level3ApproverUno.split(",").includes(selectedUser.toString())) && (x.statusUno == 3)))
        );

        this.filterApprovalCount = filterKPIData.length;
      }

      if (this.currentType == 'Completed') {
        filterKPIData = this.kpiInbox_data.filter(
          x => (
                (x.dataOwnerUno.split(",").includes(selectedUser.toString()))  ||
                (x.level1ApproverUno.split(",").includes(selectedUser.toString()))  ||
                (x.level2ApproverUno.split(",").includes(selectedUser.toString()))  ||
                (x.level3ApproverUno.split(",").includes(selectedUser.toString())) 
            )
          );

        this.filterCompletedCount = filterKPIData.length;
      }

      const mockDataset = filterKPIData;

      this.dataSearch = [];
      this.dataset = [];
      setTimeout(() => {
        this.dataSearch = mockDataset;
        this.dataset = mockDataset;
        this.columnDefinitions = [];
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }

        this.userService.refreshLeftNavCount(this.filterDataCollectionCount, this.filterApprovalCount, this.filterCompletedCount);
        this.loading = false;
        this.loadinginbox = false;
      }, 200);
    }
    else {
      if (!this.isTabClik) {
        const mockDataset = this.kpiInbox_data;

        this.dataSearch = [];
        this.dataset = [];
        setTimeout(() => {
          this.dataSearch = mockDataset;
          this.dataset = mockDataset;
          this.columnDefinitions = [];
          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
          if (this.currentType == 'Data Entry') {
            this.filterDataCollectionCount = mockDataset.length;
          }

          if (this.currentType == 'Approvals') {
            this.filterApprovalCount = mockDataset.length;
          }

          if (this.currentType == 'Completed') {
            this.filterCompletedCount = mockDataset.length;
          }


          this.userService.refreshLeftNavCount(this.filterDataCollectionCount, this.filterApprovalCount, this.filterCompletedCount);
          this.loading = false;
          this.loadinginbox = false;
        }, 200);

        

      }
      this.loading = false;
      this.loadinginbox = false;
    }
        
    
  }

  drawertoggle() {

    this.isToggle = (this.isToggle) ? false : true;
  }

  onchangeYear(e) {

    this.yearUno = (e && e.length > 0) ? e[0].value : 0;
    this.filterYear_default = this.yearUno;
    this.currentYear = this.yearUno;
    this.storeFilterValues();
    if (!this.isStart) {
      this.loadInboxDefaults();
    }
  }

  onchangeQuarter(e) {
    this.quarterUno = (e && e.length > 0) ? e[0].value : 0;
    this.currentQuarter = this.quarterUno;
    this.filterQuarter_default = this.quarterUno;
    this.storeFilterValues();
    if (!this.isStart) {
      this.loadInboxDefaults();
    }
  }

  onchangeDivision(e) {
    this.divisionUno = (e && e.length > 0) ? e[0].value : 0;
    this.filterDivision_default = this.divisionUno;
    this.storeFilterValues();
    if (!this.isStart) {
      this.loadInboxDefaults();
    }
  }

  onchangeFrequency(e) {

    this.frequencyUno = (e && e.length > 0) ? e[0].value : 0;
    this.filterFrequency_default = this.frequencyUno;
    this.storeFilterValues();
    if (!this.isStart) {
      this.loadInboxDefaults();
    }
  }

  viewKPIHistoryAll(kpiUno: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);
    this.modalRef = this.modalService.show(
      this.KPIAllHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );


  }

  onfilterData(type: string, ev: any) {
    
    let temp = this;
    this.loading = true;
    this.chkVisible = (type == 'approval') ? true : false;
    setTimeout(function () {
      temp.loading = false;
    }, 500)
    this.checkboxcheckLoaded = false;
    this.selectedUserUno = 0;
    this.isTabClik = true;
    if (type != 'color_red' && type != 'color_orange' && type != 'color_yellow' && type != 'color_lightgreen' && type != 'color_green' && type != 'color_blue') {
      this.filterDataCollection = (type == 'data') ? 1 : 0;
      this.filterOverdue = (type == 'overdue') ? 1 : 0;
      this.filterCompleted = (type == 'completed') ? 1 : 0;
      this.filterApproval = (type == 'approval') ? 1 : 0;
      this.filterAll_classactive = (type == 'all') ? 'active' : '';
      this.filterDataCollection_classactive = (type == 'data') ? 'active' : '';
      this.filterOverdue_classactive = (type == 'overdue') ? 'active' : '';
      this.filterCompleted_classactive = (type == 'completed') ? 'active' : '';
      this.filterApproval_classactive = (type == 'approval') ? 'active' : '';
      this.checkboxDisable = (this.filterDataCollection == 1 || this.filterCompleted == 1) ? false : true;
      this.filterColor = '';
      this.currentType = (type == 'data') ? 'Data Entry' : (type == 'approval') ? 'Approvals' : (type == 'completed') ? 'Completed' : 'Data Entry';

      
    }

    //for Color
    if (type == 'color_red') {

      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Red") !== -1 || !ev.target.checked) ? this.filterColor.replace('Red,', '') : this.filterColor + 'Red,';
    }
    else if (type == 'color_orange') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Orange") !== -1 || !ev.target.checked) ? this.filterColor.replace('Orange,', '') : this.filterColor + 'Orange,';
    }
    else if (type == 'color_yellow') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Yellow") !== -1 || !ev.target.checked) ? this.filterColor.replace('Yellow,', '') : this.filterColor + 'Yellow,';
    }
    else if (type == 'color_lightgreen') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Light") !== -1 || !ev.target.checked) ? this.filterColor.replace('Light Green,', '') : this.filterColor + 'Light Green,';
    }
    else if (type == 'color_green') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Green") !== -1 || !ev.target.checked) ? this.filterColor.replace('Green,', '') : this.filterColor + 'Green,';
    }
    else if (type == 'color_blue') {
      type = type + ',';
      var split_str = this.filterColor.split(",");
      this.filterColor = (split_str.indexOf("Blue") !== -1 || !ev.target.checked) ? this.filterColor.replace('Blue,', '') : this.filterColor + 'Blue,';
    }

    
    this.loadInboxDefaults();
  }

  

  handleSelectedRowsChanged1(e, args) {
    
    this.objkpiInbox_selecteddata = new kpiViewWorkFlow();
    if (Array.isArray(args.rows) && this.angularGrid) {
      let selectedrecords = this.angularGrid.gridService.getSelectedRowsDataItem();

      for (let item of selectedrecords) {
        if ((item.approver1Exists == 1 || item.approver2Exists == 1 || item.approver3Exists == 1 || this.isAdmin) && (item.level3ApprovedBy == '' && item.dataOwnerActionByUno != 0) && ((item.bandColour != '' || item.isNANRNT != '') && this.checkCurrentUserAndLevel(item))) {
          let objKR = new kpiViewWorkFlow();
          let objitem: any = item;
          objKR = objitem;
          objKR.tenantUno = 1;
          //Get The level
          let cLevel = this.getCurrentLevel(item);
          if (cLevel == 1) {
            objitem.action = 'Level 1 ';
          }
          else if (cLevel == 2) {
            objitem.action = 'Level 2 ';
          }
          else if (cLevel == 3) {
            objitem.action = 'Level 3 ';
          }
          objitem.condition = cLevel;

          this.objkpiInbox_selecteddata.objkpiViewWorkflow.push(objKR);
        }
      }

      this.isRowSelected = (this.angularGrid.gridService.getSelectedRowsDataItem().length > 0) ? true : false;
    }


  }



 

  storeFilterValues() {
    this.utilityService.InboxFilter_store(this.filterBy_default, this.filterSla_default, this.filterYear_default, this.filterQuarter_default, this.filterDivision_default, this.filterFrequency_default);
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }
  exportToExcelIssue() {
    var temp = this;
    setTimeout(function () {
      temp.issueGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.cmtsGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    let searchdataset = [];
    if (this.searchText != "") {
      searchdataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiNameEn && a.kpiNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaName && a.slaName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaRuleName && a.slaRuleName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetValueText && a.targetValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.actualValueText && a.actualValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.kpiRule && a.kpiRule.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bandValueText && a.bandValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.currentStage && a.currentStage.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    

    if (this.filterDataCollection == 1) {
      if (this.searchText != "") {
        this.dataset = searchdataset;
      }
      else {
        this.dataset = this.dataSearch;
      }
    }
    else if (this.filterApproval == 1) {
      if (this.searchText != "") {
        this.datasetApproval = searchdataset;
      }
      else {
        this.datasetApproval = this.dataSearch;
      }
    }
    else if (this.filterCompleted == 1) {
      if (this.searchText != "") {
        this.datasetCompleted = searchdataset;
      }
      else {
        this.datasetCompleted = this.dataSearch;
      }
    }
  }
  setColnDefn() {
    let temp = this;
      this.columnDefinitions = [
        {
          id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 300,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
            model: Filters.multipleSelect,
          }
        },
        //{
        //  id: 'slaName', name: 'SLA', field: 'slaName', sortable: true,
        //  type: FieldType.string, filterable: true,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'slaName', 'slaName'),
        //    model: Filters.multipleSelect,
        //  },

        //},
        {
          id: 'periodDisplay', name: 'Period', field: 'periodDisplay', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'periodDisplay', 'periodDisplay'),
            model: Filters.multipleSelect,

          }
        },

        {
          id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'slaRuleName', 'slaRuleName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'targetValueText', name: 'Actual', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true, formatter: this.actualFormatter,
          filter: {
            collection: this.uniqueArray(this.dataset, 'targetValueText', 'targetValueText'),
            model: Filters.multipleSelect,
          },
          onCellClick: (e: Event, args: OnEventArgs) => {
           
            
            let data = args.dataContext;
            if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null))
              this.DataEntryKPI(data, 'dataentry');
            if ((data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT != null && data.isNANRNT != '')) && (data.dataOwnerExists == 1 || this.isAdmin))
              this.DataEntryKPI(data, 'dataentry');
            if ((data.bandColour != '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) && (data.dataOwnerExists == 1 || this.isAdmin))
              if (data.slaRuleUno != 4)
                this.DataEntryKPI(data, 'dataentry');
          }
        },
        {
          id: 'actualValueText', name: 'Target', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'actualValueText', 'actualValueText'),
            model: Filters.multipleSelect,
          },
          formatter: (row, cell, val, columnDef, dataContext) => {
            if (dataContext.slaRuleUno != 4)
              return dataContext.actualTargetValue;
            else
              return 'Pass';
          }
        },
        {
          id: 'kpiRule', name: 'Rule', field: 'kpiRule', sortable: true, type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'bandValueText', name: 'Performance', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
          filter: {
            collection: this.uniqueArray(this.dataset, 'bandValueText', 'bandValueText'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'currentStage', name: 'Status', field: 'currentStage', sortable: true, type: FieldType.string, filterable: true,
          formatter: (row, cell, val, columnDef, data) => {
            if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno == 0)
              return '<span  class="status-area status-red">Data Entry</span>';
            else if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
              return '<span  class="status-area status-orange">Approval 1</span>';
            else if (data.level1Approved == 1 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
              return '<span  class="status-area status-yellow">Approval 2</span>';
            else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
              return '<span  class="status-area status-light-green">Approval 3</span>';
            else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 1 && data.dataOwnerActionByUno > 0)
              return '<span  class="status-area status-green">Completed</span>';
          },
          filter: {
            collection: this.uniqueArray(this.dataset, 'currentStage', 'currentStage'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
          excludeFromExport: true,
          formatter: this.actionFormatter,
          cellMenu: {
            hideCloseButton: false,
            commandTitleKey: 'COMMANDS',
            commandItems: [
              {
                command: 'Approve-row', titleKey: 'Approve_ROW', positionOrder: 62, title: 'Approve',
                itemVisibilityOverride: (args: MenuCallbackArgs) => {
                  let data = args.dataContext;

                  if ((data.approver1Exists == 1 || data.approver2Exists == 1 || data.approver3Exists == 1 || this.isAdmin) && (data.level3ApprovedBy == '' && data.dataOwnerActionByUno != 0) && (((data.bandColour != '' && (data.isNANRNT == '' || data.isNANRNT == null)) || (data.bandColour == '' && data.isNANRNT != '')) && this.checkCurrentUserAndLevel(data)))
                    return true;
                  else false;
                },
                iconCssClass: 'fa fa-check-circle fa-lg ', cssClass: 'green-text ', textCssClass: 'bold',
                action: (e, args) => {
                  this.showApproveDialog(args.dataContext)
                }
              },

              {
                command: 'Reject-row', titleKey: 'Reject_ROW', positionOrder: 64, title: 'Reject',
                iconCssClass: 'fa fa-ban fa-lg ', cssClass: 'red', textCssClass: 'bold',
                itemVisibilityOverride: (args: MenuCallbackArgs) => {
                  let data = args.dataContext;
                  if ((data.approver1Exists == 1 || data.approver2Exists == 1 || data.approver3Exists == 1 || this.isAdmin) && (data.level3ApprovedBy == '' && data.dataOwnerActionByUno != 0) && (((data.bandColour != '' && (data.isNANRNT == '' || data.isNANRNT == null)) || (data.bandColour == '' && data.isNANRNT != '')) && this.checkCurrentUserAndLevel(data)))
                    return true;
                  else false;
                },
                action: (e, args) => {
                  this.showRejectDialog(args.dataContext);
                }
              },
              {
                command: 'send-Approve-row', titleKey: 'Send_Approval_ROW', positionOrder: 62, title: 'Send for Approval',
                iconCssClass: 'fa fa-send-o fa-lg ', cssClass: 'blue', textCssClass: 'bold',
                itemVisibilityOverride: (args: MenuCallbackArgs) => {
                  let data = args.dataContext;
                  if ((data.dataOwnerExists == 1 || this.isAdmin) && data.dataOwnerActionBy == '' && (data.bandColour != '' || data.isNANRNT != ''))
                    return true;
                  else false;
                },
                action: (e, args) => {
                  this.DataEntryKPI(args.dataContext, 'dataentryapproval');
                }
              },
              {
                command: 'Comments-row', titleKey: 'Comments_ROW', positionOrder: 62, title: 'Comments',
                iconCssClass: 'fa fa-commenting fa-lg orange-text  Blink ', textCssClass: 'bold',
                itemVisibilityOverride: (args: MenuCallbackArgs) => {
                  let data = args.dataContext;
                  if (data.commentCount == 0)
                    return true;
                  else false;
                },
                action: (e, args) => {
                  let data = args.dataContext;
                  this.showCommentDialog(data.kpiTrnUno, data.kpiCode + ':' + data.kpiNameEn)
                },
              },

              {
                command: 'Comments-row', titleKey: 'Comments_ROW', positionOrder: 62, title: 'Comments',
                iconCssClass: 'fa fa-commenting fa-lg red-txt Blink ', cssClass: 'red', textCssClass: 'bold',
                itemVisibilityOverride: (args: MenuCallbackArgs) => {
                  let data = args.dataContext;
                  if (data.commentCount == 1)
                    return true;
                  else false;
                },
                action: (e, args) => {
                  let data = args.dataContext;
                  this.showCommentDialog(data.kpiTrnUno, data.kpiCode + ':' + data.kpiNameEn)
                },
              },

              {
                command: 'info-row', titleKey: 'info_ROW', positionOrder: 62, title: 'KPI Info',
                iconCssClass: 'fa fa-lg fa-info-circle  ', cssClass: 'blue', textCssClass: 'bold',
                action: (e, args) => {
                  let data = args.dataContext;
                  this.viewKPIDetails(data.kpiUno, data.kpiNameEn)
                },

              },


            ],
          }
        }
      ];
  }

  setColnDefnApprovals() {
    let temp = this;
   
    this.columnDefinitionsApproval = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'periodDisplay', name: 'Period', field: 'periodDisplay', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'periodDisplay', 'periodDisplay'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'slaRuleName', 'slaRuleName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValueText', name: 'Actual', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true, formatter: this.actualFormatter,
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'targetValueText', 'targetValueText'),
          model: Filters.multipleSelect,
        },
        onCellClick: (e: Event, args: OnEventArgs) => {
         
          
          let data = args.dataContext;
          if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null))
            this.DataEntryKPI(data, 'dataentry');
          if ((data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT != null && data.isNANRNT != '')) && (data.dataOwnerExists == 1 || this.isAdmin))
            this.DataEntryKPI(data, 'dataentry');
          if ((data.bandColour != '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) && (data.dataOwnerExists == 1 || this.isAdmin))
            if (data.slaRuleUno != 4)
              this.DataEntryKPI(data, 'dataentry');
        }
      },
      {
        id: 'actualValueText', name: 'Target', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'actualValueText', 'actualValueText'),
          model: Filters.multipleSelect,
        },
        formatter: (row, cell, val, columnDef, dataContext) => {
          if (dataContext.slaRuleUno != 4)
            return dataContext.actualTargetValue;
          else
            return 'Pass';
        }
      },
      {
        id: 'kpiRule', name: 'Rule', field: 'kpiRule', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'kpiRule', 'kpiRule'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bandValueText', name: 'Performance', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'bandValueText', 'bandValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'currentStage', name: 'Status', field: 'currentStage', sortable: true, type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno == 0)
            return '<span  class="status-area status-red">Data Entry</span>';
          else if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-orange">Approval 1</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-yellow">Approval 2</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-light-green">Approval 3</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 1 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-green">Completed</span>';
        },
        filter: {
          collection: this.uniqueArray(this.datasetApproval, 'currentStage', 'currentStage'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'Approve', field: '', maxWidth: 30,
        type: FieldType.string, formatter: (row, cell, val, columnDef, data) => { return '<span><i class="las la-check mr-2 grid-check-green"></i></span>'; },
        onCellClick: (e: Event, args: OnEventArgs) => {
          //args.dataContext;
          this.showApproveDialog(args.dataContext);
        }
      },
      {
        id: 'Reject', field: '', maxWidth: 30,
        type: FieldType.string, formatter: (row, cell, val, columnDef, data) => { return '<span><i class="las la-times mr-2 grid-times-red"></i></span>'; },
        onCellClick: (e: Event, args: OnEventArgs) => {
          //args.dataContext;
          this.showRejectDialog(args.dataContext);
        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'Approve-row', titleKey: 'Approve_ROW', positionOrder: 62, title: 'Approve',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if ((data.approver1Exists == 1 || data.approver2Exists == 1 || data.approver3Exists == 1 || this.isAdmin) && (data.level3ApprovedBy == '' && data.dataOwnerActionByUno != 0) && (((data.bandColour != '' && (data.isNANRNT == '' || data.isNANRNT == null)) || (data.bandColour == '' && data.isNANRNT != '')) && this.checkCurrentUserAndLevel(data)))
                  return true;
                else false;
              },
              iconCssClass: 'fa fa-check-circle fa-lg ', cssClass: 'green-text ', textCssClass: 'bold',
              action: (e, args) => {
                this.showApproveDialog(args.dataContext)
              }
            },

            {
              command: 'Reject-row', titleKey: 'Reject_ROW', positionOrder: 64, title: 'Reject',
              iconCssClass: 'fa fa-ban fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if ((data.approver1Exists == 1 || data.approver2Exists == 1 || data.approver3Exists == 1 || this.isAdmin) && (data.level3ApprovedBy == '' && data.dataOwnerActionByUno != 0) && (((data.bandColour != '' && (data.isNANRNT == '' || data.isNANRNT == null)) || (data.bandColour == '' && data.isNANRNT != '')) && this.checkCurrentUserAndLevel(data)))
                  return true;
                else false;
              },
              action: (e, args) => {
                this.showRejectDialog(args.dataContext);
              }
            },
            {
              command: 'send-Approve-row', titleKey: 'Send_Approval_ROW', positionOrder: 62, title: 'Send for Approval',
              iconCssClass: 'fa fa-send-o fa-lg ', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if ((data.dataOwnerExists == 1 || this.isAdmin) && data.dataOwnerActionBy == '' && (data.bandColour != '' || data.isNANRNT != ''))
                  return true;
                else false;
              },
              action: (e, args) => {
                this.DataEntryKPI(args.dataContext, 'dataentryapproval');
              }
            },
            {
              command: 'Comments-row', titleKey: 'Comments_ROW', positionOrder: 62, title: 'Comments',
              iconCssClass: 'fa fa-commenting fa-lg orange-text  Blink ', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (data.commentCount == 0)
                  return true;
                else false;
              },
              action: (e, args) => {
                let data = args.dataContext;
               
                this.showCommentDialog(data.kpiTrnUno, data.kpiCode + ':' + data.kpiNameEn)
              },
            },

            {
              command: 'Comments-row', titleKey: 'Comments_ROW', positionOrder: 62, title: 'Comments',
              iconCssClass: 'fa fa-commenting fa-lg red-txt Blink ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (data.commentCount == 1)
                  return true;
                else false;
              },
              action: (e, args) => {
                let data = args.dataContext;
                this.getKPIInformation(data);
                this.showCommentDialog(data.kpiTrnUno, data.kpiCode + ':' + data.kpiNameEn)
              },
            },

            {
              command: 'info-row', titleKey: 'info_ROW', positionOrder: 62, title: 'KPI Info',
              iconCssClass: 'fa fa-lg fa-info-circle  ', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let data = args.dataContext;
                this.viewKPIDetails(data.kpiUno, data.kpiNameEn)
              },

            },


          ],
        }
      }
    ];
      
  }

  setColnDefnCompleted() {
    let temp = this;
    //this.columnDefinitionsCompleted
    this.columnDefinitionsCompleted = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'slaName', name: 'SLA', field: 'slaName', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.datasetCompleted, 'slaName', 'slaName'),
      //    model: Filters.multipleSelect,
      //  },

      //},
      {
        id: 'periodDisplay', name: 'Period', field: 'periodDisplay', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'periodDisplay', 'periodDisplay'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'slaRuleName', name: 'KPI Type', field: 'slaRuleName', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'slaRuleName', 'slaRuleName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValueText', name: 'Actual', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true, formatter: this.actualFormatter,
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'targetValueText', 'targetValueText'),
          model: Filters.multipleSelect,
        },
        onCellClick: (e: Event, args: OnEventArgs) => {
         
          
          let data = args.dataContext;
          if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null))
            this.DataEntryKPI(data, 'dataentry');
          if ((data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT != null && data.isNANRNT != '')) && (data.dataOwnerExists == 1 || this.isAdmin))
            this.DataEntryKPI(data, 'dataentry');
          if ((data.bandColour != '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) && (data.dataOwnerExists == 1 || this.isAdmin))
            if (data.slaRuleUno != 4)
              this.DataEntryKPI(data, 'dataentry');
        }
      },
      {
        id: 'actualValueText', name: 'Target', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'actualValueText', 'actualValueText'),
          model: Filters.multipleSelect,
        },
        formatter: (row, cell, val, columnDef, dataContext) => {
          if (dataContext.slaRuleUno != 4)
            return dataContext.actualTargetValue;
          else
            return 'Pass';
        }
      },
      {
        id: 'kpiRule', name: 'Rule', field: 'kpiRule', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'kpiRule', 'kpiRule'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bandValueText', name: 'Performance', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'bandValueText', 'bandValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'currentStage', name: 'Status', field: 'currentStage', sortable: true, type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno == 0)
            return '<span  class="status-area status-red">Data Entry</span>';
          else if (data.level1Approved == 0 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-orange">Approval 1</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 0 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-yellow">Approval 2</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 0 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-light-green">Approval 3</span>';
          else if (data.level1Approved == 1 && data.level2Approved == 1 && data.level3Approved == 1 && data.dataOwnerActionByUno > 0)
            return '<span  class="status-area status-green">Completed</span>';
        },
        filter: {
          collection: this.uniqueArray(this.datasetCompleted, 'currentStage', 'currentStage'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'Approve-row', titleKey: 'Approve_ROW', positionOrder: 62, title: 'Approve',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;

                if ((data.approver1Exists == 1 || data.approver2Exists == 1 || data.approver3Exists == 1 || this.isAdmin) && (data.level3ApprovedBy == '' && data.dataOwnerActionByUno != 0) && (((data.bandColour != '' && (data.isNANRNT == '' || data.isNANRNT == null)) || (data.bandColour == '' && data.isNANRNT != '')) && this.checkCurrentUserAndLevel(data)))
                  return true;
                else false;
              },
              iconCssClass: 'fa fa-check-circle fa-lg ', cssClass: 'green-text ', textCssClass: 'bold',
              action: (e, args) => {
                this.showApproveDialog(args.dataContext)
              }
            },

            {
              command: 'Reject-row', titleKey: 'Reject_ROW', positionOrder: 64, title: 'Reject',
              iconCssClass: 'fa fa-ban fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if ((data.approver1Exists == 1 || data.approver2Exists == 1 || data.approver3Exists == 1 || this.isAdmin) && (data.level3ApprovedBy == '' && data.dataOwnerActionByUno != 0) && (((data.bandColour != '' && (data.isNANRNT == '' || data.isNANRNT == null)) || (data.bandColour == '' && data.isNANRNT != '')) && this.checkCurrentUserAndLevel(data)))
                  return true;
                else false;
              },
              action: (e, args) => {
                this.showRejectDialog(args.dataContext);
              }
            },
            {
              command: 'send-Approve-row', titleKey: 'Send_Approval_ROW', positionOrder: 62, title: 'Send for Approval',
              iconCssClass: 'fa fa-send-o fa-lg ', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if ((data.dataOwnerExists == 1 || this.isAdmin) && data.dataOwnerActionBy == '' && (data.bandColour != '' || data.isNANRNT != ''))
                  return true;
                else false;
              },
              action: (e, args) => {
                this.DataEntryKPI(args.dataContext, 'dataentryapproval');
              }
            },
            {
              command: 'Comments-row', titleKey: 'Comments_ROW', positionOrder: 62, title: 'Comments',
              iconCssClass: 'fa fa-commenting fa-lg orange-text  Blink ', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (data.commentCount == 0)
                  return true;
                else false;
              },
              action: (e, args) => {
                let data = args.dataContext;
                this.showCommentDialog(data.kpiTrnUno, data.kpiCode + ':' + data.kpiNameEn)
              },
            },

            {
              command: 'Comments-row', titleKey: 'Comments_ROW', positionOrder: 62, title: 'Comments',
              iconCssClass: 'fa fa-commenting fa-lg red-txt Blink ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (data.commentCount == 1)
                  return true;
                else false;
              },
              action: (e, args) => {
                let data = args.dataContext;
                this.getKPIInformation(data);
                this.showCommentDialog(data.kpiTrnUno, data.kpiCode + ':' + data.kpiNameEn)
              },
            },

            {
              command: 'info-row', titleKey: 'info_ROW', positionOrder: 62, title: 'KPI Info',
              iconCssClass: 'fa fa-lg fa-info-circle  ', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let data = args.dataContext;
                this.viewKPIDetails(data.kpiUno, data.kpiNameEn)
              },

            },


          ],
        }
      }
    ];
    
  }
  actualFormatter: Formatter = (row, cell, value, columnDef, data) => {

    if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno != 4)
      return data.targetValueText;
    if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno == 4)
      return data.bandColour == 'Green' ? 'Pass' : 'Fail';
    if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.dataOwnerActionBy != null && (data.isNANRNT != null && data.isNANRNT != ''))
      return data.isNANRNT;
    if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) {
      return '<a matTooltipClass="my-custom-tooltip-avg" title="Data Entry" (click)="DataEntryKPI(data,\'dataentry\')" class="bcopy-btn" style="cursor:pointer !important;">Data</a>'
    }
    if ((data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT != null && data.isNANRNT != '')) && (data.dataOwnerExists == 1 || this.isAdmin))
      return '<a  style="text-decoration:underline; cursor:pointer;" (click)="DataEntryKPI(data,\'dataentry\')">' + data.isNANRNT + '</a>';

    if ((data.bandColour != '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) && (data.dataOwnerExists == 1 || this.isAdmin))
      if (data.slaRuleUno != 4)
        return '<a style="text-decoration:underline; cursor:pointer;" (click)="DataEntryKPI(data,\'dataentry\')">' + data.targetValueText + '</a>';
      else
        return data.bandColour == 'Green' ? 'Pass' : 'Fail';

  };

  bandFormatter: Formatter = (row, cell, value, columnDef, data) => {
    if (data.slaRuleUno != 1 && data.slaRuleUno != 2 && data.bandColour == '' && (data.isNANRNT != null && data.isNANRNT != ''))
      return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    if (data.bandColour == '' && (data.slaRuleUno == 1 || data.slaRuleUno == 2) && (data.isNANRNT == 'NA' || data.isNANRNT == 'ND' || data.isNANRNT == 'NR'))
      return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    if (data.bandColour == 'Red')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (data.bandColour == 'Orange')
      return `<div class="bg-grey-progress" > <span class="orange-bar"></span></div>`;
    if (data.bandColour == 'Yellow')
      return `<div class="bg-grey-progress" > <span class="yellow-bar"></span></div>`;
    if (data.bandColour == 'Light Green')
      return `<div class="bg-grey-progress" > <span class="light-green-bar"></span></div>`;
    if (data.bandColour == 'Green')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;

  };

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;

    this.userService.angularGrid = angularGrid;
  }

  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.cmtsGrid = angularGrid;
  }
  issueGridReady(angularGrid: AngularGridInstance) {
    this.issueGrid = angularGrid;
    
  }
  setCommentDefn() {
    this.columnCommentDefinitions = [
      { id: 'action', name: 'Action', field: 'action',  sortable: true },
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Date', field: 'postedDate', sortable: true },
      { id: 'comment', name: 'Comment', field: 'comment',sortable: true},

    ];
  }

  setIssueDefn() {
    setTimeout(() => {  
    this.columnIssueDefinitions = [
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Date', field: 'postedDate', sortable: true },
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true},

      ];
    }, 1000);
  }


  viewKPIDetails(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelectedKpiInfo = kpiUno;
    this.kpinameSelectedKpiInfo = kpiNameEn;
    this.modalRef = this.modalService.show(
      this.KPIDetailsHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

  }
  onDbClicked(e, es) {
    
    let objitem = this.angularGrid.gridService.getDataItemByRowIndex(es.row)
    

    if (objitem != null && objitem != undefined) {
      this.filterBy_default = (this.filterDataCollection == 1) ? 1 : (this.filterApproval == 1) ? 2 : (this.filterCompleted == 1) ? 3 : 0;

      this.storeFilterValues();
      this.viewKPI(objitem.kpiTrnUno)
    }
  }
  myClickHandler(eve: any) { }
  getDynamicLabelData(dynamicLabel: string) {
    
    let dynamicData = [];
    let strlabel = dynamicLabel;
    this.dynamicLabel_data = [];
    if (dynamicLabel != null && dynamicLabel != '') {

      dynamicData = dynamicLabel.split(' ');
      for (var i = 0; i < dynamicData.length; i++) {
        if (dynamicData[i].indexOf('@') != -1) {
          this.dynamicLabel_data.push(dynamicData[i]);

          let filterData = this.trnDynamicLabel_data.filter(x => x.kpiDynamicLabel == dynamicData[i]);
          if (filterData.length > 0 && filterData[0].kpiDynamicValue != null) {
            strlabel = strlabel.replace(dynamicData[i], filterData[0].kpiDynamicValue);
          }

        }
      }
      this.dynamicLabelDisplay = strlabel;
      this.showEntryDialog();
    }
    else {
      this.dynamicLabel_data = [];
    }


  }
  loadKPIDynamicTransaction(kpiTrnUno: number) {
    
    this.spinner.show();
    let inpValue = new kpiDynamic();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getKpiDynamicsTransaction(inpValue)
      .subscribe(data => {

        // let objData: any = data;
        
        this.trnDynamicLabel_data = data;
        this.getDynamicLabelData(this.kpiCodeDetail.dynamicLabel);
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  showEntryDialog() {
    
    this.dynamicBinding_data = [];
    for (var i = 0; i < this.dynamicLabel_data.length; i++) {
      if (this.dynamicLabel_data[i] != '') {
        let label = this.dynamicLabel_data[i];
        let filterData = this.trnDynamicLabel_data.filter(x => x.kpiDynamicLabel == this.dynamicLabel_data[i]);

        if (filterData != null && filterData.length > 0) {
          let item = { label: this.dynamicLabel_data[i], value: filterData[0].kpiDynamicValue };
          this.dynamicBinding_data.push(item);
        }
        else {
          let item = { label: this.dynamicLabel_data[i], value: '' };
          this.dynamicBinding_data.push(item);
        }
      }
    }
    

  }

  uploadFiles() {
    
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
        return false;
      }
      let formData = new FormData();
      let isFileReadyForUpload = false;
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let allowFile = false;
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        let allowFileSize = false;
        allowFileSize = this.userService.checkFileSize(fileSize);
        if (!allowFileSize) {
          this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
          return;
        }
        //To check filee size exe  
        allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

        if (allowFile) {
          formData.append("file", this.uploadedFiles[i]);
          isFileReadyForUpload = true;
        }
      }
      if (isFileReadyForUpload) {

        formData.append("kpiUno", this.kpiUnoSelected.toString());
        formData.append("kpiTrnUno", this.kpiTrnUno.toString());
        formData.append("userID", this.login_UserID.toString());
        this.restApi.kpiDynamicsAttachmentUpload(formData)
          .subscribe(data => {
            
            if (data == null && data == undefined && data == '') {

            }
            else {
              //  this.toaster.show('success', 'Success', 'File uploaded.');
              //this.RefreshDirectory();
              //this.selectedRecord = new fileManager();
              this.uploadedFiles = [];


            }

            this.spinner.hide();
          },
            (error) => {
              this.spinner.hide();
            }
          ).add(() => {
            this.spinner.hide();
          });
      }
    }
    //else {
    //  this.toaster.show('error', 'Error', 'Please select the file');
    //}
  }
  onTest() {
    alert();
  }

  getUsers() {

    let inpValue = new user();
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
       
        this.user_data_filter = data;
        
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getPerformanceText(bandColor: string) {
    let rtnText: string = ''
    if (bandColor == 'green-bar')
      rtnText = "Well Performing";
    else if (bandColor == 'red-bar')
      rtnText = "Under Performing";
    else if (bandColor == 'gray-bar')
      rtnText = "Pending Result";
    else
      rtnText = '';

    return rtnText;
  }

  getPerformanceBackground(bandColor: string) {
    let rtnText: string = ''
    if (bandColor == 'green-bar')
      rtnText = "bg-light-green";
    else if (bandColor == 'red-bar')
      rtnText = "bg-light-orange";
    else if (bandColor == 'gray-bar')
      rtnText = "bg-light-grey";
    else
      rtnText = '';
    return rtnText;
  }
  

  approvalJustificationIssue() {

    let Items = [];
    for (var i = 0; i < this.datasetIssues.length; i++) {
      Items.push({
        ActionBy: this.datasetIssues[i].postedBy,
        Date: this.datasetIssues[i].postedDate,
        Comment: this.datasetIssues[i].comment,
      });
    }

    // Excel Title, Header, Data
    const header = Object.keys(Items[0]);

    var ExcelData = [];
    for (let i = 0; i < Items.length; i++) {
      ExcelData.push(Object.values(Items[i]));

    }

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

   
    worksheet.getCell("A1").value = "KPI Name";
    worksheet.getCell("A1").font = { bold: true };
    worksheet.getCell("B1").value = this.kpiNameText;

    worksheet.getCell("A2").value = "Period";
    worksheet.getCell("A2").font = { bold: true };
    worksheet.getCell("B2").value = this.periodText;

    worksheet.getCell("A3").value = "Frequency";
    worksheet.getCell("A3").font = { bold: true };
    worksheet.getCell("B3").value = this.scheduleText;

    worksheet.getCell("A4").value = "Target";
    worksheet.getCell("A4").font = { bold: true };
    worksheet.getCell("B4").value = this.targetValueText;

    worksheet.getCell("A5").value = "Actual";
    worksheet.getCell("A5").font = { bold: true };
    worksheet.getCell("B5").value = this.actualValueText;

    worksheet.getCell("A6").value = "";
    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd8ebdc' },
        bgColor: { argb: '' }
      };
      cell.font = { name: 'DubaiW23-Regular', family: 8, size: 10, bold: true, color: { argb: '000000' }, };
     // cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // // Add Data  
    ExcelData.forEach(d => {
      const row = worksheet.addRow(d);
    }
    );

    worksheet.getColumn(1).width = 25;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 25;
  
   
  
    // Generate Excel File with given name
    var dataVal: any;
    var filename = "Export_Justification";
    workbook.xlsx.writeBuffer().then((data: any) => {
      dataVal = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
     
      //if (window.navigator.msSaveOrOpenBlob) //IE & Edge
      //{
      //  //msSaveBlob only available for IE & Edge
      //  window.navigator.msSaveBlob(dataVal, filename);
      //}
      const nav = (window.navigator as any); //IE & Edge
      if (nav.msSaveOrOpenBlob)
      {
        nav.msSaveBlob(dataVal, filename);
      }
      else //Chrome & FF
      {
        var url = window.URL.createObjectURL(dataVal);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }
    });
    
  }
  getKPIInformation(data: any) {
    this.kpiNameText = data.kpiNameEn;
    this.periodText = data.periodDisplay;
    this.targetValueText = data.targetValueText;
    this.actualValueText = data.actualValueText;
    this.scheduleText = data.scheduleText;
  }
}


